import {
    Box,
    Button,
    CircularProgress,
    TextField,
    useTheme,
} from "@mui/material";
import { ChangeEvent, FormEvent, useContext, useState } from "react";

import { Add } from "@mui/icons-material";
import { Global_CTX } from "../../contexts/global-ctx";
import { Admin_Service, INew_Admin } from "../../services/admin/admin-service";
import { Autocomplete } from "../Autocomplete/Autocomplete";
// import New_Feedback from "../feedback";

const initial_admin: INew_Admin = {
    name: "",
    orgId: "",
    username: "",
    password: "",
};

export default function Create_Admin_Form() {
    const [admin, set_admin] = useState(initial_admin);
    const { feedback, set_feedback, set_refetch_counter } =
        useContext(Global_CTX);
    const theme = useTheme();

    const handle_change = (ev: ChangeEvent<HTMLInputElement>) => {
        const value = ev.target.value;
        set_admin({
            ...admin,
            [ev.target.name]: value,
        });
    };

    const handle_submit = async (ev: FormEvent) => {
        ev.preventDefault();
        set_feedback({ ...feedback, loading: true });
        const [data, error] = await Admin_Service.createAdmin(admin);

        if (error) {
            set_feedback({
                loading: false,
                message: { title: error.message },
                severity: "error",
                show: true,
            });
            return;
        }

        if (data) {
            set_feedback({
                loading: false,
                message: { title: data.message },
                severity: "success",
                show: true,
            });

            set_refetch_counter((n) => n + 1);
        }
    };

    return (
        <form
            onSubmit={handle_submit}
            style={{
                display: "flex",
                gap: theme.spacing(2),
            }}
        >
            <TextField
                label="Name"
                fullWidth
                value={admin.name}
                name="name"
                onChange={handle_change}
                sx={{ flex: 1 }}
                required
            />

            <TextField
                label="Username"
                fullWidth
                value={admin.username}
                name="username"
                onChange={handle_change}
                sx={{ flex: 1 }}
                required
            />

            <TextField
                label="Password"
                fullWidth
                value={admin.password}
                name="password"
                onChange={handle_change}
                sx={{ flex: 1 }}
                required
            />

            <Box sx={{ flex: 1 }}>
                <Autocomplete
                    api={"/organization"}
                    setOutput={(org) => {
                        set_admin({ ...admin, orgId: org.code });
                    }}
                    labelKey={"name"}
                    label="Organization"
                />
            </Box>

            <Button
                type="submit"
                variant="contained"
                disabled={feedback.loading}
                startIcon={
                    feedback.loading ? <CircularProgress size="1em" /> : <Add />
                }
            >
                {feedback.loading ? "Creating Admin..." : "Create Admin"}
            </Button>
        </form>
    );
}
